import { render, staticRenderFns } from "./AppLayoutWidgets.vue?vue&type=template&id=2f0a0c7e&"
import script from "./AppLayoutWidgets.vue?vue&type=script&lang=js&"
export * from "./AppLayoutWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports